import { Action } from '@ngrx/store';

export const UNLOCK_ACCOUNT_SUCCESS = '[Customer] User Unlock Account Success';

export class UnlockAccountSuccessAction implements Action {
  readonly type = UNLOCK_ACCOUNT_SUCCESS;

  constructor(public payload: { user: { key: string, identifier: string }, status: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/UnlockAccountSuccessAction.ts